import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import ComenzarIncodeIndex from '../ComenzarIncode';


export function RedirigirMovil() {

    const history = useHistory();
   

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Redirect To Mobile Incode');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])


    const valPermisos = {
        required: 'Campo obligatorio',
    };


    return (
        <div className="">
            <Header type="complete" />
            <ComenzarIncodeIndex />
        </div>
    )
}